import { render } from "./SelectSlider.vue?vue&type=template&id=ab0357fc&scoped=true&lang=html"
import script from "./SelectSlider.vue?vue&type=script&lang=js"
export * from "./SelectSlider.vue?vue&type=script&lang=js"

import "./SelectSlider.vue?vue&type=style&index=0&id=ab0357fc&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab0357fc"]])

export default __exports__